/* Pause and sound for the editorial video band.

   The browser's own controls arrive as a black bar across the foot of the
   band, which on a full-bleed clip is the one place the image was supposed
   to run to. So the band gets two marks in its corners instead, and this
   drives them.

   The clip still plays by itself - oj-video-autoplay.js starts it when it
   scrolls into view and stops it when it leaves, so only one clip on the
   page ever decodes at a time. What this adds is a reader who wants out of
   that: a pause here sets data-oj-paused, which that script reads as "leave
   this one alone", so scrolling past and back does not quietly start it
   again. Pressing play clears the flag and hands it back. */

(function () {
  function init(root) {
    var video = root.querySelector('[data-oj-ed-video]');
    var controls = root.querySelector('[data-oj-ed-controls]');
    if (!video || !controls) return;

    var toggle = controls.querySelector('[data-oj-ed-toggle]');
    var mute = controls.querySelector('[data-oj-ed-mute]');

    /* The labels are on the buttons in the markup, in the shop's own
       language; swapping them means reading the opposite state back off
       the same element rather than hardcoding a second language here. */
    var labelPause = toggle.getAttribute('aria-label');
    var labelPlay = toggle.getAttribute('data-label-play') || 'Spela filmen';
    var labelUnmute = mute.getAttribute('aria-label');
    var labelMute = mute.getAttribute('data-label-mute') || 'Stäng av ljudet';

    function paint() {
      var playing = !video.paused;
      root.classList.toggle('is-playing', playing);
      toggle.setAttribute('aria-label', playing ? labelPause : labelPlay);
      root.classList.toggle('is-muted', video.muted);
      mute.setAttribute('aria-label', video.muted ? labelUnmute : labelMute);
    }

    toggle.addEventListener('click', function () {
      if (video.paused) {
        video.removeAttribute('data-oj-paused');
        var started = video.play();
        if (started && started.catch) started.catch(function () {});
      } else {
        // Set before pausing: the observer reads the flag on its next pass,
        // and a scroll can fire between the two.
        video.setAttribute('data-oj-paused', '');
        video.pause();
      }
      paint();
    });

    mute.addEventListener('click', function () {
      video.muted = !video.muted;
      /* Sound on almost always means the reader also wants it running -
         unmuting a paused clip does nothing audible otherwise. */
      if (!video.muted && video.paused) {
        video.removeAttribute('data-oj-paused');
        var started = video.play();
        if (started && started.catch) started.catch(function () {});
      }
      paint();
    });

    // The observer plays and pauses behind our back, so follow it.
    video.addEventListener('play', paint);
    video.addEventListener('pause', paint);
    video.addEventListener('volumechange', paint);

    paint();
  }

  function boot() {
    // Any element that declares itself a player - the hero and the band
    // both do, so the page's two clips behave the same way.
    document.querySelectorAll('[data-oj-ed-player]').forEach(function (el) {
      if (el.dataset.ojEdVideoReady) return;
      el.dataset.ojEdVideoReady = '1';
      init(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // The theme editor re-renders a section in place when a setting changes.
  document.addEventListener('shopify:section:load', boot);
})();
